import apiClient from '../base/apiClient';

export const dashboardApi = {
  getTotalMonthlyIncome: async () => {
    const response = await apiClient.get('/Administration/Dashboard/CountTotalMonthlyIncome');
    if (response.data.errorMessage) throw new Error(response.data.errorMessage);
    if (response.data.error) throw new Error(response.data.error);
    return { data: { incomeCount: response.data.incomeCount || 0, errorMessage: response.data.errorMessage || null } };
  },

  getMonthlyNewOrders: async () => {
    const response = await apiClient.get('/Administration/Dashboard/CountMonthlyNewOrders');
    if (response.data.errorMessage) throw new Error(response.data.errorMessage);
    if (response.data.error) throw new Error(response.data.error);
    return { data: { orderCount: response.data.orderCount || 0, errorMessage: response.data.errorMessage || null } };
  },

  getMonthlyActiveOrders: async () => {
    const response = await apiClient.get('/Administration/Dashboard/CountMonthlyActiveOrders');
    if (response.data.errorMessage) throw new Error(response.data.errorMessage);
    if (response.data.error) throw new Error(response.data.error);
    return { data: { orderCount: response.data.orderCount || 0, errorMessage: response.data.errorMessage || null } };
  },

  getMonthlyNewUsers: async () => {
    const response = await apiClient.get('/Administration/Dashboard/CountMonthlyNewUsers');
    if (response.data.errorMessage) throw new Error(response.data.errorMessage);
    if (response.data.error) throw new Error(response.data.error);
    return { data: { accountCount: response.data.accountCount || 0, errorMessage: response.data.errorMessage || null } };
  },

  getDailyIncome: async () => {
    const response = await apiClient.get('/Administration/DashBoard/DailyIncomeThisMonth');
    if (response.data.errorMessage) throw new Error(response.data.errorMessage);
    if (response.data.error) throw new Error(response.data.error);
    return { data: { incomeCount: response.data.incomeCount || 0, errorMessage: response.data.errorMessage || null } };
  },

  getDailyNewOrders: async () => {
    const response = await apiClient.get('/Administration/DashBoard/DailyNewOrdersThisMonth');
    if (response.data.errorMessage) throw new Error(response.data.errorMessage);
    if (response.data.error) throw new Error(response.data.error);
    return { data: { orderCount: response.data.orderCount || 0, errorMessage: response.data.errorMessage || null } };
  },

  getListUnverifiedContractors: async (params: { filter?: string; page?: number; perPage?: number } = {}) => {
    const { filter = '', page = 0, perPage = 100 } = params;
    const response = await apiClient.get('/Administration/Dashboard/ListUnverifiedContractors', { params: { filter, page, count: perPage } });
    if (response.data.errorMessage) throw new Error(response.data.errorMessage);
    if (response.data.error) throw new Error(response.data.error);
    const contractors = response.data.users || [];
    return {
      data: contractors.map((contractor: any) => ({
        id: contractor.id || contractor.userId,
        username: contractor.username,
        firstName: contractor.firstName,
        middleName: contractor.middleName || '',
        lastName: contractor.lastName,
        email: contractor.email,
        thumbnailImageUrl: contractor.thumbnailImageUrl ? `${apiClient.defaults.baseURL}${contractor.thumbnailImageUrl}` : '',
        phoneNumber: contractor.phoneNumber,
        isContractorVerified: contractor.isContractorVerified,
      })),
      total: response.data.total || contractors.length,
    };
  },

  getListActiveOrders: async (params: { filter?: string; page?: number; perPage?: number } = {}) => {
    const { filter = '', page = 0, perPage = 100 } = params;
    const response = await apiClient.get('/Administration/Dashboard/ListActiveOrders', { params: { filter, page, count: perPage } });
    if (response.data.errorMessage) throw new Error(response.data.errorMessage);
    if (response.data.error) throw new Error(response.data.error);
    const orders = response.data.orders || [];
    return {
      data: orders.map((order: any) => ({
        id: order.orderId || order.id,
        flowId: order.flowId,
        fulfilledById: order.fulfilledById,
        postedByFullName: order.postedByFullName,
        postedByThumbnail: order.postedByThumbnail ? `${apiClient.defaults.baseURL}${order.postedByThumbnail}` : '',
        fulfilledTimestamp: order.fulfilledTimestamp,
        postedTimestamp: order.postedTimestamp,
        postedById: order.postedById,
        flowState: order.flowState,
        title: order.title,
        brief: order.brief,
        description: order.description,
      })),
      total: response.data.total || orders.length,
    };
  },

  getListRecentTopups: async (params: { filter?: string; page?: number; perPage?: number } = {}) => {
    const { filter = '', page = 0, perPage = 10 } = params;
    const response = await apiClient.get('/Administration/Dashboard/ListRecentTopups', { params: { filter, page, num: perPage } });
    if (response.data.errorMessage) throw new Error(response.data.errorMessage);
    if (response.data.error) throw new Error(response.data.error);
    const transactions = response.data.transactions || [];
    return {
      data: transactions.map((transaction: any) => ({
        id: transaction.id || transaction.transactionId,
        timestamp: transaction.timestamp,
        fullName: transaction.fullName || transaction.username,
        thumbnail: transaction.thumbnail ? `${apiClient.defaults.baseURL}${transaction.thumbnail}` : '',
        transactionType: transaction.transactionType,
        orderId: transaction.orderId,
        orderDetails: transaction.orderDetails,
        description: transaction.description,
        amount: transaction.amount,
      })),
      total: response.data.total || transactions.length,
    };
  },
};